import React, { useId } from 'react'
import { Link } from 'gatsby'
import Card from 'react-bootstrap/Card'
import { Partner as PartnerType } from 'types'
import { getTextShort } from '@helpers/helper.rendering' 

interface PropsType {
    skeleton?: boolean,
    partner?: PartnerType
}

const Partner = (props: PropsType) => {

    const {partner, skeleton} = props;

    return (
        <Link to={partner?.link ? partner?.link : ""} 
            id={"partner-id" + useId()} className={"partner-wrapper link d-flex" + (partner?.link ? " cursor-pointer" : "") + (skeleton ? " skeleton-card" : "")}>
            <Card className="text-center partner-card">
                <Card.Body className={"d-flex flex-column align-items-center position-relative p-0" + (skeleton ? " skeleton-body" : "")}
                style={{backgroundImage: `url(${!skeleton || partner?.image ? partner?.image : ""})`}}>
                    <Card.Text className="d-flex align-items-center p-5 position-relative">
                        <span className="text-content d-flex flex-column">
                            { partner?.title ? <b className="mb-2">{partner?.title}</b> : null}
                            { partner?.description ? getTextShort(partner?.description, 130) : null }
                        </span>
                    </Card.Text>
                </Card.Body>
            </Card>
        </Link>
    )
}

export default Partner